const baseurl_sql =
  window.__RUNTIME_CONFIG__?.REACT_APP_SQL_BASE_URL ||
  process.env.REACT_APP_SQL_BASE_URL;
const baseurl_neo4j =
  window.__RUNTIME_CONFIG__?.REACT_APP_NEO4J_BASE_URL ||
  process.env.REACT_APP_NEO4J_BASE_URL;
const baseurl =
  window.__RUNTIME_CONFIG__?.REACT_APP_BASE_URL ||
  process.env.REACT_APP_BASE_URL;

export const GET_INDEXES = baseurl + "/get_indexes";
export const CREATE_INDEX = baseurl + "/create_index_pgvector_bulk";
export const DELETE_INDEX = baseurl + "/delete_index_pg";
export const CREATE_INDEX_IMG_DOC = baseurl + "/create_index_pgvector_img_doc";

export const ADD_IMAGES = baseurl + "/upload_image_api";
export const CHAT_WITH_IMAGE = baseurl + "/chat_image_data";
export const GET_IMAGES = baseurl + "/get_image_api";
export const DELETE_IMAGE = baseurl + "/delete_image_api";

export const CHAT_DEFAULT = baseurl + "/chat_default_model";
export const CHAT_WITH_RAG = baseurl + "/chat_rag_for_docs_new";

export const GET_MODELS = baseurl + "/get_models";

export const GET_USER_DETAILS = baseurl + "/get_user_details_new";
export const GET_USER_TYPE = baseurl + "/get_user_type";

export const GET_USER_CONVERSATIONS = baseurl + "/get_conv_list";
export const DELETE_CONVERSATION = baseurl + "/del_single_conv";
export const CREATE_NEW_CONVERSATION = baseurl + "/create_new_conv";
export const UPDATE_CONVERSATION_NAME = baseurl + "/update_conv_name_user";
export const FIRST_MESSAGE_CHANGE_CONVERSATION_NAME =
  baseurl + "/change_conversation_name";

export const UPDATE_USER_SETTINGS = baseurl + "/update_user_settings";
export const GET_CONV_BY_USER_ID = baseurl + "/get_chats_for_conv";

export const GET_USER_PROMPTS = baseurl + "/get_user_queries";
export const SAVE_USER_PROMPT = baseurl + "/save_user_query";
export const DELETE_USER_PROMPT = baseurl + "/delete_user_query";
export const UPDATE_USER_PROMPT = baseurl + "/update_user_query";

export const UPDATE_REQUEST = baseurl + "/update_provision_request";
export const RAISE_REQUEST = baseurl + "/raise_request";
export const GET_REQUEST = baseurl + "/get_request_details";

export const GET_PROVISION_DETAILS = baseurl + "/get_provision_details";

export const GET_DASHBOARD = baseurl + "/get_dashboard_requests";
export const GET_DASHBOARD_USER = baseurl + "/get_dashboard_users";
export const GET_DASHBOARD_MODELS = baseurl + "/get_dashboard_models";

export const GET_USER_NAMES = baseurl + "/get_dashboard_user_mapping";

export const GET_SQL_USERS = baseurl_sql + "/get_sql_db_names";
export const UPLOAD_SQL_CONFIG = baseurl_sql + "/add_sql_creds";
export const LOADING_SQL_DB = baseurl_sql + "/load_sql_config_v2";
export const CHAT_WITH_SQL = baseurl_sql + "/chat_sql_chain_api";
export const WAKE_UP_SQL_DB = baseurl_sql?.slice(0, -4);
export const GET_SQL_DATA = baseurl_sql + "/get_sql_data";
export const DELETE_SQL_CONFIG = baseurl_sql + "/delete_sql_db";

export const GET_IMAGE_DATA = baseurl + "/get_image_data";
export const GET_SHARED_IMAGE_DATA = baseurl + "/get_shared_image_data";

export const GET_USER_FORMATS = baseurl + "/get_user_formats";
export const SAVE_USER_FORMAT = baseurl + "/save_user_formats";
export const DELETE_USER_FORMAT = baseurl + "/delete_user_formats";
export const UPDATE_USER_FORMAT = baseurl + "/update_user_format";

export const GET_TABLE = baseurl + "/get_table_output";

export const GET_EXCEL = baseurl + "/get_excel_db_names";
export const UPLOAD_EXCEL = baseurl + "/upload_excel";
export const CHAT_WITH_EXCEL = baseurl + "/chat_excel";
// export const LOAD_EXCEL = baseurl_sql + "/load_excel_file";
export const DELETE_EXCEL = baseurl + "/delete_excel_file";
export const GET_EXCEL_DATA = baseurl + "/get_excel_data";

export const GET_SHARED_DOCS = baseurl + "/get_shared_docs";
export const GET_WITH_WHOM_DOCS_IS_SHARED = baseurl + "/get_shared_with_docs";
export const SHARE_DOCS_WITH = baseurl + "/share_doc_with_user";
export const GET_DOCUMENT_OWNER = baseurl + "/get_document_owner";

export const GET_SHARED_IMAGES = baseurl + "/get_shared_imgs";
export const SHARE_IMAGES_WITH = baseurl + "/share_img_with_user";
export const GET_WITH_WHOM_IMAGES_IS_SHARED = baseurl + "/get_shared_with_imgs";
export const GET_IMAGES_OWNER = baseurl + "/get_image_owner";

export const GET_SHARED_COLLECTION = baseurl + "/get_shared_collections";
export const GET_WITH_WHOM_COLLECTION_IS_SHARED =
  baseurl + "/get_shared_with_collection";
export const SHARE_COLLECTION_WITH = baseurl + "/share_collection_with_user";
export const GET_COLLECTION_OWNER = baseurl + "/get_collection_owner";

export const UPLOAD_YOUTUBE_URL = baseurl + "/upload_url";
export const GET_YT_VIDEOS = baseurl + "/get_user_video_list";
export const DELETE_YT_VIDEOS = baseurl + "/delete_video";
export const CHAT_WITH_VIDEO = baseurl + "/chat_video";

export const UPLOAD_NEO4J_CONFIG = baseurl_neo4j + "/upload_neo4j_db";
export const CHAT_WITH_NEO4J = baseurl_neo4j + "/chat_neo4j_chain_api";
export const GET_NEO4J_DB_NAMES = baseurl_neo4j + "/get_neo4j_db_names";
export const DELETE_NEO4J_DB = baseurl_neo4j + "/delete_neo4j_db";
export const GET_NEO4J_NODES_AND_RELS =
  baseurl_neo4j + "/get_nodes_and_relations";

export const DELETE_SHARED_DOCUMENT = baseurl + "/delete_shared_user_doc";
export const DELETE_SHARED_IMAGES = baseurl + "/delete_shared_user_img";
export const DELETE_SHARED_COLLECTION =
  baseurl + "/delete_shared_user_collection";

export const GET_USER_FOLDERS = baseurl + "/get_user_folders";
export const CREATE_USER_FOLDER = baseurl + "/create_user_folder";
export const UPDATE_COLLECTION = baseurl + "/update_files_for_multiple";
export const DELETE_FILES_FROM_COLLECTION =
  baseurl + "/delete_file_for_multiple";
export const DELETE_USER_FOLDER = baseurl + "/delete_user_folder";
export const CHAT_WITH_MULTIPLE_SOURCES = baseurl + "/chat_multiple_sources";
export const GET_AZURE_SPEECH_TOKEN = baseurl + "/azure-speech-token";

export const GET_USER_EMAILS = baseurl + "/get_user_emails";

export const GENERATE_PROMPT = baseurl + "/chat_prompt_gen";
